import { render, staticRenderFns } from "./RoleToUser.vue?vue&type=template&id=2c28b777"
import script from "./RoleToUser.vue?vue&type=script&lang=js"
export * from "./RoleToUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports